import EfSpec from '@elem/ui/ef-spec';
import EfProductCompare2 from '@elem/ui/ef-product-compare-2';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t: ta } = useLang('theProduct.CompareA.A');
    const { t: tb } = useLang('theProduct.CompareA.B');
    const { t: tc } = useLang('theProduct.CompareA');

    const keyArr: string[] = ['Auto-switch', 'Battery', 'Cost', 'Runtime', 'Input', 'Output', 'Data communication', 'Management software', 'Noise'];

    const getData = (p: 'ta' | 'tb') => {
        let t = ta;
        switch (p) {
            case 'tb':
                t = tb;
                break;
        }

        return {
            title: t('title'),
            subTitle: t('subTitle'),
            url:
                p === 'ta'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1732349655469/Compare1.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1732349682483/Compare2.png',
            data: {
                [tc('key_1') || keyArr[0]]: t('Auto-switch'),
                [tc('key_2') || keyArr[1]]: t('Battery'),
                [tc('key_3') || keyArr[2]]: t('Cost'),
                [tc('key_4') || keyArr[3]]: t('Runtime'),
                [tc('key_5') || keyArr[4]]: t('Input'),
                [tc('key_6') || keyArr[5]]: t('Output'),
                [tc('key_7') || keyArr[6]]: t('Data communication') === '1' ? true : false,
                [tc('key_8') || keyArr[7]]: t('Management software') === '1' ? true : false,
                [tc('key_9') || keyArr[8]]: t('Noise'),
            },
        };
    };
    return (
        <div className={styles.TheComp} id={PageNavType.Comparison}>
            <EfSpec />
            <EfProductCompare2 dataGroupA={getData('ta')} dataGroupB={getData('tb')} />
            {/* <img src="https://websiteoss.ecoflow.com/upload/image/1732172722968/Frame%201000009104.png" /> */}
        </div>
    );
}
